module.exports = __webpack_public_path__ + "static/media/vote.52bec181.png";